import { MasterCardIcon, VisaCardIcon } from '@modules/CustomIcons'
import { TableProps } from '@shared/Table'
import { Col, Row, Typography } from 'antd'
import { t } from 'i18next'
import { SalaryCardType } from 'store/types/salaryCard'

type MSalaryCardType = Omit<SalaryCardType, 'key' | 'rejectedCount'> & {
  rejectedCount?: number
}

export const orderListColumns: () => TableProps<MSalaryCardType>['editColumns'] =
  () => ({
    createdDate: {
      title: t('orders.salaryCardOrder.tableTitles.date'),
      hasSorter: true,
      hasSelect: true,
      width: 150,
      fixed: 'left',
    },
    orderNo: {
      title: t('orders.salaryCardOrder.tableTitles.number'),
      hasSearch: true,
      width: 150,
    },
    cardType: {
      title: t('orders.salaryCardOrder.inputLabels.cardType'),
      i18nKeyForLabel: 'orders.salaryCardOrder.constants',
      hasSelect: true,
      render(value) {
          return <Row justify="start" align="middle" gutter={8}>
            {value === 'VISA' ? <VisaCardIcon /> : <MasterCardIcon />}
            <Col>{value === 'VISA' ? 'Visa': 'MasterCard'}</Col>
          </Row>
      },
      width: 150
    },
    cardCurrency: {
      title: t('orders.salaryCardOrder.tableTitles.cardCurrency'),
      hasSelect: true,
      width: 100,
      align: 'center'
    },
    orderType: {
      title: t('orders.salaryCardOrder.tableTitles.orderTypes'),
      i18nKeyForLabel: 'orders.salaryCardOrder.constants',
      hasSelect: true,
      width: 130,
      align: 'center',
      render(value) {
        return <>
          { t(`orders.salaryCardOrder.constants.${value}`) }
        </>
    },
      
    },
    orderDeliveryType: {
      title: t('orders.salaryCardOrder.tableTitles.receivingTransfer'),
      hasSelect: true,
      i18nKeyForLabel: 'orders.salaryCardOrder.constants',
      width: 130,
      align: 'center',
      render(value) {
        return <>
          { t(`orders.salaryCardOrder.constants.${value}`) }
        </>
    },
    },
    totalCount: {
      title: t('orders.salaryCardOrder.tableTitles.totalNumberOfRejections'),
      width: 100,
      align: 'center',
      render(value, record, index) {
        return (
          <>
            {value}/
            <Typography.Text type='danger'>{record?.rejectedCount}</Typography.Text>
          </>
        )
      },
    },
    status: {
      width: 100,
      title: t('orders.salaryCardOrder.tableTitles.status'),
      render(value) {
        return <>
          { t(`orders.salaryCardOrder.buttonsLabels.RadioButtonGroup.${value}`) }
        </>
    },
      fixed: 'right'
    },
  })
